import { connect } from 'react-redux'
import Header from './Header'

import selectIsFiltered from './Selectors/selectIsFiltered'

import onChangeSearch from './Handlers/onChangeSearch'
import onSearch from './Handlers/onSearch'
import onChangeFilter from './Handlers/onChangeFilter'
import onClickExport from './Handlers/onClickExport'
import onChangeMode from './Handlers/onChangeMode'

const mapStateToProps = (state) => ({
  projectStatuses: state.core.projectStatuses,
  subcontractors: state.core.subcontractors,
  projects: state.core.projects,
  users: state.core.users,
  search: state.screens.Subbies.SubProjects.search,
  filters: state.screens.Subbies.SubProjects.filters,
  isFiltered: selectIsFiltered(state),
  mode: state.screens.Subbies.SubProjects.mode,
})

const actionCreators = {
  onChangeSearch,
  onSearch,
  onChangeFilter,
  onClickExport,
  onChangeMode,
}

export default connect(mapStateToProps, actionCreators)(Header)
